import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home.vue'
import CaseStudy from '@/components/CaseStudy.vue'

import Login from '@/components/Auth/Login.vue'
import Register from '@/components/Auth/Register.vue'
import PasswordReset from '@/components/Auth/PasswordReset.vue'
import PasswordChange from '@/components/Auth/PasswordChange.vue'
import Activate from '@/components/Auth/Activate.vue'

import DashboardBase from '@/components/Dashboard/Base.vue'
import DashboardProjects from '@/components/Dashboard/Projects.vue'
import DashboardReferrals from '@/components/Dashboard/Referrals.vue'

import ProjectBase from '@/components/Projects/Base.vue'
import ProjectOverview from '@/components/Projects/Overview.vue'
import ProjectDocuments from '@/components/Projects/Documents.vue'
import ProjectTeam from '@/components/Projects/Team.vue'
import ProjectInvoices from '@/components/Projects/Invoices.vue'

import Refer from '@/components/Pages/Refer.vue'

import Profile from '@/components/Members/Profile.vue'

import RequestProposal from '@/components/Auth/RequestProposal.vue'

import Services from '@/components/Pages/Services.vue'
import About from '@/components/Pages/About.vue'
import Contact from '@/components/Pages/Contact.vue'

import AdmonitionsScroll from '@/components/Pages/Work/AdmonitionsScroll.vue'

import Alex from '@/components/Pages/People/Alex.vue'

import NotAgency from '@/components/Pages/Promo/NotAgency.vue'

import Error404 from '@/components/Pages/404.vue'

import { store } from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      name: 'home-referral',
      path: '/ref/:referralKey',
      component: Home,
      props: true
    },
    {
      name: 'case-study',
      path: '/portfolio/:id/:slug?',
      component: CaseStudy,
      props: true
    },
    // Auth
    {
      name: 'login',
      path: '/login/:loginCode?',
      component: Login,
      props: true
    },
    {
      name: 'register',
      path: '/join',
      component: Register
    },
    {
      name: 'password-reset',
      path: '/password/reset',
      component: PasswordReset
    },
    {
      name: 'password-change',
      path: '/password/change',
      component: PasswordChange,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'activate',
      path: '/me/join/:code',
      component: Activate,
      props: true
    },
    // Dashboard
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardBase,
      redirect: '/dashboard/projects',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          name: 'dashboard-projects',
          path: 'projects',
          component: DashboardProjects
        },
        {
          name: 'dashboard-referrals',
          path: 'referrals',
          component: DashboardReferrals
        }
      ]
    },
    // Projects
    {
      path: '/projects',
      component: ProjectBase,
      props: true,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          name: 'project-overview',
          path: ':id',
          props: true,
          component: ProjectOverview
        },
        {
          name: 'project-documents',
          path: ':id/documents',
          props: true,
          component: ProjectDocuments
        },
        {
          name: 'project-team',
          path: ':id/team',
          props: true,
          component: ProjectTeam
        },
        {
          name: 'project-invoices',
          path: ':id/invoices',
          props: true,
          component: ProjectInvoices
        }
      ]
    },
    // Members
    {
      name: 'profile',
      path: '/profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    // Additional features
    {
      name: 'request-proposal',
      path: '/proposal',
      component: RequestProposal
    },
    {
      name: 'services',
      path: '/services/',
      component: Services
    },
    {
      name: 'contact',
      path: '/contact/',
      component: Contact
    },
    {
      name: 'refer',
      path: '/refer/',
      component: Refer
    },
    // Static pages
    {
      name: 'about',
      path: '/about/',
      component: About
    },
    {
      name: 'admonitions-scroll',
      path: '/admonitions-scroll/',
      component: AdmonitionsScroll
    },
    {
      name: 'alex',
      path: '/alex',
      component: Alex
    },
    {
      name: 'not-an-agency',
      path: '/not-an-agency',
      component: NotAgency
    },
    {
      path: '*',
      component: Error404
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.auth.isLoggedIn) {
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router
